<div class="row spacer-top-large">

    <div class="col-sm-12 div-learn-fun" role="main">

    <div class="col-sm-12" role="main">
    <h2 class="text-center text-primary">learning with fun</h2>
        <h3 class="text-center">Turn your computer and mobile phone into a learning zone</h3>

    </div>

</div>
</div>
<div class="row row-pitch2">
    <div class="col-sm-12">
        <h3 class="text-center text-primary">Why Should Boldungu be part of Child's education</h3>
    </div>

    <div class="col-sm-6 text-center">
        <div class="row-pitch-inner">
            <ul>
                <li>
                    <i class="fa fa-check text-success"></i>
                    Unlimited Learning
                </li>
                <li>
                    <i class="fa fa-check text-success"></i>
                    Decide on the questions and areas for assesment
                </li>
                <li>
                    <i class="fa fa-check text-success"></i>
                    Access to Unlimited Questions
                </li>
            </ul>
        </div>
    </div>
    <div class="col-sm-6 text-center">
        <div class="row-pitch-inner">
            <ul>
                <li>
                    <i class="fa fa-check text-success"></i>
                    Monitor your students performace
                </li>
                <li>
                    <i class="fa fa-check text-success"></i>
                    digital versions of relevant examples and illustrations
                </li>
                <li>
                    <i class="fa fa-check text-success"></i>
                    Solutions and tips to different areas
                </li>
            </ul>
        </div>
    </div>


</div>
